import React from 'react';
import fetch from '../../fetch';
import utils from '../../../utils';
import {Progress,Tag } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    // {type: 'selection'},
    {key:'$index', label: '序号' , width : 80},
    {key:'orgName', label: '部门名称',width : 120},
    {key:'majorName', label: '专业名称' ,width : 120},
    {key:'classesName', label: '班级名称' ,width : 120},
    {key:'studentName', label: '学生姓名' ,width : 120},
    {key:'graduationGrade', label: '届别' ,width : 120},
    {key:'employeeName', label: '指导教师' ,width : 120},
    {key:'title', label: '论文题目' ,width : 120},
    // {key:'progress', label: '录入进度' ,width : 120, render:(val)=>{
    //             return  <Progress percent={val==null?0:val} />
    //         }},
    {key:'entringStatus', label: '审核状态', width: 85, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>待提交</Tag>)},
    {key:'termName', label: '学期' ,width : 120},
    
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/graduation/templateEntring/auditQuery?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const remove = (ids) => {
    return fetch.post('graduation/templateEntring/delete' , ids)
}

const update = (data) => {
    return fetch.post('graduation/templateEntring/update/'+data.id , data)
}

const getResultContentById = (id)=> {
    return fetch.get(`graduation/templateEntring/getResultContent/${id}`)
}

const save = (data) => {
    return fetch.post('graduation/templateEntring/save', data);
}

const onSubmit = (id)=> {
    return fetch.get(`graduation/templateEntring/onSubmit/${id}`)
}

const auditResult = (id, data) => {
    return fetch.post('graduation/templateEntring/audit/' + id, data)
    .then(response => {
        // debugger
        // Modal.success({
        //     title: '提示信息',
        //     content: (
        //         <div>
        //             <p>{response.message}</p>
        //         </div>
        //     ),
        //     okText:"确认",
        //     onOk() {
        //         DataGrid.selections = [];
                return response;
        //     },
        // });
        
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}


export default {
    columns,
    onSelect,
    setRefresh,
    getSelection,
    querySearch ,
    delete : remove,
    update,
    save,
    getResultContentById,
    onSubmit,
    auditResult,
    download : `${fetch.base}graduation/result/file/download/`
}

